var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-20rem h-10rem bdw-1 bdr-4 bdc-p bgc-p flex-row flex-ac"},[_c('div',{style:({ width: '9rem', height: '9rem' }),attrs:{"id":_vm.getId}}),_c('div',{staticClass:"color-w flex-col mb-40"},[_c('h2',{},[_vm._v(_vm._s(_vm.title))]),_c('h2',{staticClass:"mt-10"},[_vm._v(_vm._s(_vm.sum))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }